'use strict';
app.service("geoStreamApiService", function ($rootScope, $http, $timeout) {
        const self = this;
        const urlGISAPI = $rootScope["giswebApiurl"];
        const CONFIG = {
            SAS_BACKEND_URL: `${urlGISAPI}mapfilestorage/get_sas_url`,
            CANCEL_BACKEND_URL: `${ urlGISAPI }mapfilestorage/cancel_upload`,
            CREATE_RECORD_BACKEND_URL: `${urlGISAPI}mapfilestorage/create_record_upload_log`,
            GET_RECORD_STATUS_URL: `${urlGISAPI}mapfilestorage/get_record_status_log`,
            SAVE_DATA_TRANS_URL: `${urlGISAPI}mapfilestorage/save_data_trans`,
            GET_DATA_TRANS_URL: `${urlGISAPI}mapfilestorage/get_data_trans`,
            SAS_COG_BACKEND_URL: `${urlGISAPI}mapfilestorage/get_sas_url_cog`,
            PUBLISH_COG_PREVIEW_URL: `${urlGISAPI}mapfilestorage/create_store_and_publish_cog_layer_preview`,
            PUBLISH_COG_LIVE_URL: `${urlGISAPI}mapfilestorage/create_store_and_publish_cog_layer_live`,
            DELETE_COG_BLOB_URL: `${urlGISAPI}mapfilestorage/delete_cog_blob`,
            PROCESS_COG_FOOTPRINT_URL: `${urlGISAPI}mapfilestorage/process_cog_footprint`,
            GET_COG_FOOTPRINT_STATUS_URL: `${urlGISAPI}mapfilestorage/get_cog_footprint_status`,
            GET_COG_PUBLISH_STATUS_URL: `${urlGISAPI}mapfilestorage/get_cog_publish_status`,
            LIST_COG_TILES_URL: `${urlGISAPI}mapfilestorage/list_cog_tiles`,
            GET_COG_LAYER_BBOX_URL: `${urlGISAPI}mapfilestorage/get_cog_layer_bbox`,
            GET_COG_TILE_BBOX_URL: `${urlGISAPI}mapfilestorage/get_cog_tile_bbox`,
            GET_COVERAGE_STORE_TYPE_URL: `${urlGISAPI}mapfilestorage/get_coverage_store_type`,
            CLEAR_PREVIEW_COG_LAYER_URL: `${urlGISAPI}mapfilestorage/clear_preview_cog_layer`
        };

        this.getSasData = async function (clientCode, ouCode, filename, type) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.SAS_BACKEND_URL,
                    params: {
                        clientCode: clientCode,
                        ouCode: ouCode,
                        filename: filename,
                        type: type
                    }
                });

                return response.data;

            } catch (err) {
                throw new Error('Error. The request to upload file is unauthorized. Please contact support.');
            }
        };

        this.saveDataTrans = async function (clientCode, ouCode) {
            const url = CONFIG.SAVE_DATA_TRANS_URL;
            try {
                await $http({
                    method: 'POST',
                    url: url,
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: {
                        ClientCode: clientCode,
                        OuCode: ouCode
                    }
                });
            }
            catch (err) {
                console.error("Save record failed", err);
                throw err;
            }
        };

        this.getDataTrans = async function (ouKey) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.GET_DATA_TRANS_URL,
                    params: {
                        ouKey: ouKey
                    },
                    responseType: 'json'
                });

                return response.data;
            }
            catch (err) {
                console.error("Get data trans failed", err);
                throw err;
            }
        };

        this.notifyCreateRecord = async function (clientCode, ouCode, jobId, originalFullBlobPath, originalRelativeBlobPath, type) {
            const url = CONFIG.CREATE_RECORD_BACKEND_URL;

            try {
                await $http({
                    method: 'POST',
                    url: url,
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: {
                        ClientCode: clientCode,
                        OuCode: ouCode,
                        JobId: jobId,
                        OriginalFullBlobPath: originalFullBlobPath,
                        OriginalRelativeBlobPath: originalRelativeBlobPath,
                        LayerType: type
                    }
                });
            }
            catch (err) {
                console.error("Create record failed", err);
                throw err;
            }
        };

        this.notifyCancelRecord = async function (clientCode, ouCode, jobId, type) {
            const url = CONFIG.CANCEL_BACKEND_URL;

            try {
                await $http({
                    method: 'POST',
                    url: url,
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: {
                        ClientCode: clientCode,
                        OuCode: ouCode,
                        JobId: jobId,
                        LayerType: type
                    }
                });
            }
            catch (err) {
                console.error("Cancel record failed", err);
                throw err;
            }
        };

        this.getUploadAuditInfo = async function (clientCode, ouCode, jobId) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.GET_RECORD_AUDIT_INFO_URL,
                    params: {
                        clientCode: clientCode,
                        ouCode: ouCode,
                        filename: filename,
                        type: type
                    }
                });

                return response.data;

            } catch (err) {
                throw new Error('Error. The request to upload file is unauthorized. Please contact support.');
            }
        }

        function pollUntilDone({ fetchStatus, getPercent, onProgress, isDone, getResult, isError, getErrorMessage, intervalMs = 1500, timeoutIfNoProgressMs = 2 * 60 * 1000, isCancelled = () => false, stallTimeoutMs = 0, getProgressKey = getPercent, isNotStarted = () => false }) {
            const pollingStartedAt = Date.now();
            let hasProgress = false;
            let hasStarted = false;
            let isWaitingToStart = false;
            let lastProgressAt = pollingStartedAt;
            let lastProgressKey;
            return new Promise((resolve, reject) => {
                const poll = async () => {
                    if (isCancelled()) {
                        reject(new Error('Polling cancelled.'));
                        return;
                    }
                    try {
                        const status = await fetchStatus();
                        if (isCancelled()) {
                            reject(new Error('Polling cancelled.'));
                            return;
                        }
                        if (status) {
                            const percent = getPercent(status) || 0;
                            if (percent > 0) hasProgress = true;
                            isWaitingToStart = !hasStarted && isNotStarted(status);
                            if (!isWaitingToStart) hasStarted = true;
                            if (stallTimeoutMs > 0) {
                                const progressKey = getProgressKey(status);
                                if (progressKey !== lastProgressKey) {
                                    lastProgressKey = progressKey;
                                    lastProgressAt = Date.now();
                                }
                            }
                            if (onProgress) onProgress(status, percent);

                            if (isDone(status)) {
                                resolve(getResult ? getResult(status) : status);
                                return;
                            }
                            if (isError(status)) {
                                reject(new Error((getErrorMessage && getErrorMessage(status)) || 'Failed'));
                                return;
                            }
                        }

                        // A job the backend has never recorded is not running, so it gets the short timeout.
                        const stallLimitMs = isWaitingToStart ? Math.min(stallTimeoutMs, timeoutIfNoProgressMs) : stallTimeoutMs;
                        if (stallTimeoutMs > 0 && Date.now() - lastProgressAt >= stallLimitMs) {
                            const error = new Error('Publish progress stalled. GeoServer may be overloaded -- please try again later or contact support.');
                            error.code = 'PUBLISH_STALLED';
                            reject(error);
                            return;
                        }

                        if (!stallTimeoutMs && !hasProgress && (Date.now() - pollingStartedAt) >= timeoutIfNoProgressMs) {
                            reject(new Error('Timed out with no progress. Please contact support.'));
                            return;
                        }

                        $timeout(poll, intervalMs);
                    } catch (err) {
                        reject(err);
                    }
                };
                poll();
            });
        }

        this.pollProcessingStatus = async function (clientCode, ouCode, jobId, type, onProgress, onComplete, onError, isCancelled) {
            try {
                const destFilename = await pollUntilDone({
                    fetchStatus: async () => {
                        const response = await $http({
                            method: 'GET',
                            url: CONFIG.GET_RECORD_STATUS_URL,
                            params: { clientCode, ouCode, jobId, type }
                        });
                        return response.data;
                    },
                    getPercent: data => data.Percent,
                    onProgress: (data, percent) => onProgress(percent),
                    isDone: data => data.Status === 'PROCESSED' || data.Percent === 100,
                    getResult: data => data.DestFilename,
                    isError: data => data.Status === 'ERROR',
                    getErrorMessage: data => data.Remarks || 'Processing failed',
                    intervalMs: 2500,
                    ...(isCancelled ? { isCancelled } : {})
                });
                onComplete(destFilename);
            } catch (err) {
                onError(err);
            }
        };

        this.publishToLive = async function (clientCode, ouCode, jobId, type, liveUrl, confirmOverwriteDifferentType) {
            try {
                const response = await $http.post(liveUrl, {
                    clientCode: clientCode,
                    ouCode: ouCode,
                    jobId: jobId,
                    type: type,
                    confirmOverwriteDifferentType: !!confirmOverwriteDifferentType
                });

                return response.data;

            }
            catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to publish live (${status})`);
            }
        };

        this.getCoverageStoreType = async function (clientCode, ouCode, isCog = false) {
            const response = await $http({
                method: 'GET',
                url: CONFIG.GET_COVERAGE_STORE_TYPE_URL,
                params: { clientCode, ouCode, isCog }
            });
            return response.data.type;
        };

        this.publishPreviewLayer = async function (clientCode, ouCode, jobId, type, previewUrl) {
            try {
                const response = await $http.post(previewUrl, {
                    clientCode: clientCode,
                    ouCode: ouCode,
                    jobId: jobId,
                    type: type
                });

                return response.data;

            }
            catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to publish preview layer - (${status})`);
            }
        };

        this.deleteStore = async function (clientCode, ouCode, type, deleteUrl) {
            try {
                await $http.post(deleteUrl, {
                    clientCode: clientCode,
                    ouCode: ouCode,
                    type: type
                });

                return true;

            }
            catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to delete (${status})`);
            }
        };

        this.checkLayerExistence = async function (geoserverUrl, workspace, layer) {
            const checkUrl = `${geoserverUrl}${workspace}/wms?service=WMS&version=1.1.1&request=GetMap&exceptions=application/json&layers=${encodeURI(layer)}`;
            const response = await fetch(checkUrl);
            if (!response.ok) return false;

            const exceptions = (await response.json())?.exceptions || [];
            return exceptions.findIndex(ex => ex?.code === 'LayerNotDefined') === -1;
        };

        this.getSasUrlCog = async function (clientCode, ouCode, originalFilename) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.SAS_COG_BACKEND_URL,
                    params: {
                        clientCode: clientCode,
                        ouCode: ouCode,
                        originalFilename: originalFilename
                    }
                });

                return response.data;
            } catch (err) {
                throw new Error('Error. The request to upload COG file is unauthorized. Please contact support.');
            }
        };

        this.publishPreviewCogLayer = async function (clientCode, ouCode, granules) {
            try {
                const response = await $http.post(CONFIG.PUBLISH_COG_PREVIEW_URL, {
                    clientCode: clientCode,
                    ouCode: ouCode,
                    granules: granules
                });

                return response.data;
            } catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to publish COG preview layer - (${status})`);
            }
        };

        this.publishCogToLive = async function (clientCode, ouCode, granules, excludeGranules, confirmOverwriteDifferentType) {
            try {
                const response = await $http.post(CONFIG.PUBLISH_COG_LIVE_URL, {
                    clientCode: clientCode,
                    ouCode: ouCode,
                    granules: granules,
                    excludeGranules: excludeGranules,
                    confirmOverwriteDifferentType: !!confirmOverwriteDifferentType
                });

                return response.data;
            } catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to publish COG live (${status})`);
            }
        };


        this.clearPreviewCogLayer = async function (clientCode, ouCode) {
            try {
                await $http.post(CONFIG.CLEAR_PREVIEW_COG_LAYER_URL, { clientCode: clientCode, ouCode: ouCode });
                return true;
            } catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to clear preview COG layer (${status})`);
            }
        };

        this.deleteCogBlob = async function (clientCode, ouCode, blob) {
            await $http.post(CONFIG.DELETE_COG_BLOB_URL, { clientCode: clientCode, ouCode: ouCode, container: blob.container, relativeBlobPath: blob.relativeBlobPath });
        };

        this.processCogFootprint = async function (clientCode, ouCode, relativeBlobPath) {
            try {
                const response = await $http.post(CONFIG.PROCESS_COG_FOOTPRINT_URL, { clientCode: clientCode, ouCode: ouCode, relativeBlobPath: relativeBlobPath });
                return response.data;
            } catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to process COG footprint (${status})`);
            }
        };

        this.getCogFootprintStatus = async function (relativeBlobPath) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.GET_COG_FOOTPRINT_STATUS_URL,
                    params: { relativeBlobPath: relativeBlobPath }
                });
                return response.data;
            } catch (err) {
                return null;
            }
        };

        this.getCogPublishStatus = async function (jobId) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.GET_COG_PUBLISH_STATUS_URL,
                    params: { jobId: jobId }
                });
                return response.data;
            } catch (err) {
                return null;
            }
        };

        this.pollCogFootprintProgress = function (relativeBlobPath, onProgress, isCancelled) {
            return pollUntilDone({
                fetchStatus: () => self.getCogFootprintStatus(relativeBlobPath),
                getPercent: status => status.percent,
                onProgress: (status, percent) => { if (onProgress) onProgress(percent); },
                isDone: status => status.stage === 'done',
                isError: status => status.stage === 'error',
                getErrorMessage: status => status.error || 'Footprint processing failed',
                ...(isCancelled ? { isCancelled } : {})
            });
        };

        this.pollCogPublishJob = function (jobId, onProgress, isCancelled) {
            return pollUntilDone({
                fetchStatus: () => self.getCogPublishStatus(jobId),
                getPercent: status => status.percent,
                onProgress: (status, percent) => { if (onProgress) onProgress(status.stage, percent); },
                isDone: status => status.stage === 'done',
                isError: status => status.stage === 'error',
                getErrorMessage: status => status.error || 'Publish failed',
                // Allow the backend's 10-minute GeoServer timeout before verifying a stalled job.
                stallTimeoutMs: 12 * 60 * 1000,
                // updatedOn changes on every backend heartbeat, even when stage and percent repeat.
                getProgressKey: status => `${status.stage}:${status.percent || 0}:${status.updatedOn || ''}`,
                isNotStarted: status => status.stage === 'unknown',
                ...(isCancelled ? { isCancelled } : {})
            });
        };

        this.listCogTiles = async function (clientCode, ouCode) {
            const response = await $http({
                method: 'GET',
                url: CONFIG.LIST_COG_TILES_URL,
                params: { clientCode: clientCode, ouCode: ouCode }
            });
            return response.data;
        };

        this.getCogLayerBbox = async function (clientCode, ouCode) {
            const response = await $http({
                method: 'GET',
                url: CONFIG.GET_COG_LAYER_BBOX_URL,
                params: { clientCode: clientCode, ouCode: ouCode }
            });
            return response.data;
        };

        this.getCogTileBbox = async function (clientCode, ouCode, blob) {
            const response = await $http({
                method: 'GET',
                url: CONFIG.GET_COG_TILE_BBOX_URL,
                params: { clientCode: clientCode, ouCode: ouCode, container: blob.container, relativeBlobPath: blob.relativeBlobPath }
            });
            return response.data;
        };

    });
